export default __webpack_public_path__ + "static/media/heart.42b78f61.png";